// Import necessary React hooks
import { useState } from "react";
// Import necessary Material-UI components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
// Import custom validation function and hooks
import { validateItemInput } from "../../validation/validateItemInput.js";
import { useNewRequestContext, useNewRequest } from "../../hooks";
import {
  ItemDetailsFormCommon,
  CustomBackdrop,
  processImages,
} from "../../../common";
// Import UUID utilities
import { v1 as uuidv1 } from "uuid";

export function AddItemSampleRequestModal(props) {
  // Function to close the modal
  const handleClose = () => props.setOpen(false);
  // State to store any validation errors
  const [errors, setErrors] = useState();
  // Hook to set sample request details
  const { setSampleRequestDetails } = useNewRequest();
  // Hook to access the current state of the new request
  const { state } = useNewRequestContext();
  // State to store new product images to be uploaded
  const [productImages, setProductImages] = useState([]);
  // State for storing boolean for progress of image compression
  const [isCompressing, setIsCompressing] = useState(false);
  // State for storing timer for Secondary Message in CustomBackdrop
  const [patienceTimer, setPatienceTimer] = useState(false);

  // State for storing form input values
  const [values, setValues] = useState({
    sampleItemID: "",
    itemERPCode: "",
    itemDescription: "",
    specification: "",
    quantityForSample: "",
    preferredUnitOfMeasure: "",
    productClass: "",
  });

  // Handler for form input changes
  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // Function to handle form submission for adding a new item
  const handleSetData = async (data) => {
    // Reset any existing errors
    setErrors({});

    // Process all of the images primed for upload - compress images and then convert to base64 before uploading
    let productImagesToUpload = await processImages(
      productImages,
      setPatienceTimer,
      setIsCompressing
    );

    // Update the sample request details with the new data, including the compressed images
    setSampleRequestDetails({
      ...state.sampleRequestDetails,
      items: [
        ...state.sampleRequestDetails.items,
        {
          ...data,
          itemERPCode: values.itemERPCode ? values.itemERPCode : "N/A",
          sampleItemID: `SI-ID-${uuidv1()}`,
          productImage: productImagesToUpload,
        },
      ],
    });
    // Logic to Reset form states
    setValues({
      sampleItemID: "",
      itemERPCode: "",
      itemDescription: "",
      specification: "",
      quantityForSample: "",
      preferredUnitOfMeasure: "",
      productClass: "",
    });
    // Clear the product images array
    setProductImages([]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const { validationErrors, isValid } = validateItemInput(values);
    !isValid && setErrors(validationErrors);

    isValid && handleSetData(values);
  };
  errors && console.log({ errors });

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        style={{
          height: "90%",
        }}
        PaperProps={{ sx: { borderRadius: "20px" } }}
      >
        <Box
          sx={{
            display: props.display,
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Container
            component="main"
            maxWidth="sm"
            sx={{
              marginTop: 4,
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5">
              Add Item
            </Typography>
            <CssBaseline />
            <Box
              component="form"
              noValidate
              sx={{
                mt: 5,
              }}
            >
              {/*  Form fields and components for adding item details */}
              <ItemDetailsFormCommon
                values={values}
                onChange={onChange}
                errors={errors}
                productImage={productImages}
                setProductImage={setProductImages}
              />
              <Grid
                container
                spacing={2}
                sx={{
                  mt: 1,

                  flexDirection: "row",
                  justifyContent: "center",
                }}
              >
                <Grid item>
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                      textTransform: "capitalize",
                    }}
                  >
                    Close
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 3,
                      width: "150px",
                      textTransform: "capitalize",
                    }}
                  >
                    Add Item
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
      <CustomBackdrop
        open={isCompressing}
        primaryMessage="Please wait: Compressing selected images"
        timer={patienceTimer}
        secondaryMessage="Larger images take longer to compress."
      />
    </div>
  );
}
